import { Component, OnInit } from '@angular/core';
import {ChooseDoctorListModalComponent} from "../choose-doctor-list-modal/choose-doctor-list-modal.component";
import {MenuController, ModalController} from "@ionic/angular";

@Component({
  selector: 'app-notification-detail',
  templateUrl: './notification-detail.component.html',
  styleUrls: ['./notification-detail.component.scss'],
})
export class NotificationDetailComponent implements OnInit {

  constructor(private modalController: ModalController, private menu: MenuController) { }

  ngOnInit() {}

  dismiss(){
    this.modalController.dismiss();
  }
  ionViewWillEnter() {
    this.menu.enable(false);
  }
  ionViewWillLeave() {
    this.menu.enable(true);
  }
}
